import { useShallow } from "zustand/shallow";

import Vehicles from "containers/Vehicles";
import useBoundStore from "store";

interface EventVehiclesVotesProps {
  onBack?: () => void;
}

export default function EventVehiclesVotes(props: EventVehiclesVotesProps): JSX.Element {
  const { onBack } = props;
  const selected = useBoundStore((state) => state.selected);
  const { groups, groupsUsers, votes } = useBoundStore(
    useShallow((state) => ({
      groups: state.appData.groups,
      groupsUsers: state.appData.groupsUsers,
      votes: state.appData.votes,
    }))
  );

  const group = groups.find((g) => g.id === selected.groupId);
  const users = groupsUsers.filter((user) => group?.users.includes(user.uid));
  const filteredVotes = votes.filter((vote) => vote.event_id === selected.eventId);

  return <Vehicles users={users} votes={filteredVotes} onBack={onBack} />;
}
